module.exports = __webpack_public_path__ + "static/img/active-1.5815dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/active-1.jpg
// module id = 28y1
// module chunks = 1